import React from 'react';
import PropTypes from 'prop-types';
import {TimerPopup} from './TimerPopup';
import {TimerMain} from './TimerImages';
import {TimerControl} from './TimerControl';
import className from './style.module.scss';
import {splitTime, composeTime, timerFinished, EMPTY_TIME} from './Timer.utils';

let timerRunInterval = null;
/**
 * Timer:
 *   Lab Equipment with a timer; You can set a particular timer and make the timer run
 *   down the set time.
 */
export class Timer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: this.props.time,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.time !== this.props.time) {
      this.setState({time: this.props.time});
    }
  }

  stopTimer = () => {
    clearInterval(timerRunInterval);
    this.props.setRunning(false);
    this.props.setTime(this.state.time);
    this.callBack((this.props.time.getTime() - this.state.time.getTime()) / 1000);
  };

  forceStopTimer = () => {
    clearInterval(timerRunInterval);
    this.props.setRunning(false);
    this.setState(
      {
        time: EMPTY_TIME,
      },
      () => {
        this.props.setTime(this.state.time)
        this.callBack((this.props.time.getTime() - this.state.time.getTime()) / 1000);
      }
    );
  };

  callBack = (timePassed) => {
    if(timePassed >= this.props.callback.amount){
      this.props.callback.function(timePassed);
      this.setState({
        timePassed: 0
      })
    }
  }

  runTimer = () => {
    const [h, m, s] = splitTime(this.state.time);
    this.setState(
      {
        time: composeTime(h, m, s - 1),
      },
      () => {
        timerFinished(this.state.time) && this.stopTimer();
      }
    );
  };

  startTimer = () => {
    this.props.setRunning(true);
    if (timerRunInterval) clearInterval(timerRunInterval);
    timerRunInterval = setInterval(
      this.runTimer,
      this.props.defaultTimeUpdateRate
    );
  };

  openPopup = (event) => {
    event.stopPropagation();
    this.props.setShowPopup(true);
  };

  closePopup = (event) => {
    event.stopPropagation();
    this.props.setShowPopup(false);
  };

  getDisplayTime = () =>
    this.props.running ? this.state.time : this.props.time;

  getFooterButtonCallback = () => {
    if (this.props.running) return this.forceStopTimer;
    else return this.props.onClickDone;
  };

  render() {
    return (
      <div className={className.timer} onClick={this.openPopup}>
        <TimerMain className={className.labIcon} />
        <TimerPopup
          onClose={this.closePopup}
          isOpen={this.props.showPopup}
          skipTimer={this.props.running}
          onFooterClick={this.getFooterButtonCallback()}
          className={className.modal}>
          <TimerControl
            time={this.getDisplayTime()}
            setTime={this.props.setTime}
            startTimer={this.startTimer}
            disabled={this.props.running}
          />
        </TimerPopup>
      </div>
    );
  }
}

Timer.propTypes = {
  /**
   * Boolean to set if popup should be displayed
   */
  showPopup: PropTypes.bool,
  /**
   * Function to set/reset popup display
   */
  setShowPopup: PropTypes.func,
  /**
   * Boolean to set if timer is running
   */
  running: PropTypes.bool,
  /**
   * Function to set/reset running
   */
  setRunning: PropTypes.func,
  /**
   * time to display on timer
   */
  time: PropTypes.instanceOf(Date),
  /**
   * Fuction to update Time
   */
  setTime: PropTypes.func,
  /**
   * Callback for Done button in Footer
   */
  onClickDone: PropTypes.func,
};

Timer.defaultProps = {
  defaultTimeUpdateRate: 250,
};

/**
 * Used class Component because setRunning(false) and setTime(time)
 * in functional components needs to run in parallel with setTime() [stat update operation]
 * This was giving render warnings
 */
